import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { ServiceLocationAddedEvent } from '@platform/event-bus/domain/events/service-location.event';
import { ServiceStateService } from '@features/service/application/services/service-state.service';
import { ServiceLocationChangedEvent, ServiceLocationRemovedEvent } from '@platform/event-bus/domain/events/service-location.event';
import {merge} from 'rxjs';


@Injectable({ providedIn: 'root' })
export class ServiceLocationSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly serviceStateService = inject(ServiceStateService);

  constructor() {
    merge(
      this.eventBus.ofType(ServiceLocationAddedEvent),
      this.eventBus.ofType(ServiceLocationRemovedEvent)
    ).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      const currentLocation = this.serviceStateService.getCurrentLocation();

      const exists = this.serviceStateService.getAllLocations().some(location => location.id === currentLocation?.id);

      if (!exists) {
        this.eventBus.publish(new ServiceLocationChangedEvent());
      }
    });

  }
}
